import { motion } from "motion/react";
import { ArrowRight, MessageSquare } from "lucide-react";
import { useTranslation } from "react-i18next";

const HERO_IMAGE_URL = "https://lh3.googleusercontent.com/aida-public/AB6AXuCC5Wm68EasA2Ntqr7XoJjXx7iXij6Q1dG47t6FhCtKoj-cxLY57hKjh1zAMGCdf30C4NMXiMj97SrFxR-2oMh_FdwW5XI8vQL7DRHQlaeG8YUgZSPdt3XTeN4CfV6VSd0ZMl-kkkzUSNjNkH8LyEE5IzW1phCrFdN4tqrP--w0KXjSXkmnUMKyX1UOfdsRWelSx1xmfhPS2f1Tdohwl5JS9JDa04jrv35zeCi36IzWYESD-N_M-47dXI9bsI4PABZW1XgM9We7ybI";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden py-12 lg:py-20">
      <div
        className="absolute inset-0 bg-no-repeat bg-center opacity-60 -z-10"
        style={{
          backgroundImage: `url(${HERO_IMAGE_URL})`,
          backgroundSize: '100% auto'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-white/70 to-white -z-10" />
      <div className="absolute inset-0 opacity-10 pointer-events-none -z-10" style={{ backgroundImage: "radial-gradient(#897362 1px, transparent 1px)", backgroundSize: "20px 20px" }} />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col items-center text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-flex items-center gap-2 px-3 py-1 bg-surface-container-low border border-outline-variant rounded-full mb-8"
        >
          <span className="w-2 h-2 rounded-full bg-primary-container animate-pulse" />
          <span className="text-[12px] font-bold text-on-surface-variant uppercase tracking-wider">{t('hero.badge')}</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-4xl md:text-6xl font-bold text-on-surface max-w-4xl mb-6 leading-[1.1] tracking-tight"
        >
          {t('hero.title')}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15 }}
          className="text-lg md:text-xl text-on-surface-variant max-w-3xl mb-4 leading-relaxed"
        >
          {t('hero.subtitle')}
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-base text-on-surface-variant/70 max-w-2xl mb-10 leading-relaxed"
        >
          {t('hero.description')}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto"
        >
          <button id="cta-products" className="bg-primary-container text-white px-8 py-4 rounded-lg font-bold hover:bg-orange-600 transition-all flex items-center justify-center gap-2 group">
            {t('hero.cta_products')}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
          <button id="cta-consult" className="border-2 border-secondary-container text-on-surface px-8 py-4 rounded-lg font-bold hover:bg-secondary-container/10 transition-all flex items-center justify-center gap-2">
            {t('hero.cta_consult')}
            <MessageSquare className="w-5 h-5" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
